import { Status } from "../../components/ui";
import { hideChatAndFastTrack } from "../../lib/featureFlags";
import type { AgentInputMode, AgentVisibility } from "../api/e2e";

export function AgentVisibilityBadge({
  visibility,
}: {
  visibility: AgentVisibility;
}) {
  return (
    <Status tone={visibility === "public" ? "success" : "neutralBg"}>
      {visibility === "public" ? "Public" : "Private"}
    </Status>
  );
}

export function AgentInputModeBadge({ mode }: { mode: AgentInputMode }) {
  return (
    <Status tone={mode === "canalyst" ? "tint" : "neutralBg"}>
      {mode === "canalyst" ? "Canalyst" : "Research"}
    </Status>
  );
}

export function AgentRunTrackBadge({ fast }: { fast: boolean }) {
  if (hideChatAndFastTrack()) return null;

  return (
    <Status tone={fast ? "warning" : "neutral"}>
      {fast ? "Fast" : "Standard"}
    </Status>
  );
}
